module.exports = __webpack_public_path__ + "static/img/anli1.af37380.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli/anli1.gif
// module id = +viR
// module chunks = 1